import React from "react";
import { useAuth } from "../context/AuthContext";
import { Button } from "../components/ui/button";
import { Check, ShieldCheck, Flag } from "lucide-react";
import { toast } from "sonner";
import { motion } from "framer-motion";

export default function Upgrade() {
  const { user } = useAuth();

  const features = [
    "Save unlimited runs — your data never disappears",
    "Full season analytics & performance trends",
    "Weather auto-fill from your GPS location",
    "Virtual pit crew invites",
    "Everything unlocked — one-time purchase",
  ];

  const handlePayPal = () => {
    // PayPal checkout script to be wired in later
    toast("PayPal checkout is coming soon — hang tight!", { icon: "💳" });
  };

  return (
    <div className="mx-auto max-w-lg">
      <motion.div initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }}>
        <div className="mb-5 flex items-center gap-2 text-mt-primary">
          <Flag size={16} /> <span className="text-xs font-bold uppercase tracking-[0.25em]">Unlock MyTrackApp</span>
        </div>

        {user?.plan === "paid" ? (
          <div className="rounded-2xl border border-mt-success bg-mt-success/5 p-8 text-center" data-testid="already-paid">
            <ShieldCheck size={40} className="mx-auto text-mt-success" />
            <h1 className="mt-3 font-head text-2xl font-bold">You're all set!</h1>
            <p className="mt-1 text-sm text-mt-mutedfg">Your account is fully unlocked. Go log some runs. 🏁</p>
          </div>
        ) : (
          <div className="overflow-hidden rounded-2xl border border-mt-border bg-mt-card shadow-sm" data-testid="upgrade-card">
            <div className="bg-mt-text p-8 text-white">
              <h1 className="font-head text-3xl font-black tracking-tighter">Own it forever</h1>
              <p className="mt-1 text-white/70">One-time purchase. No subscription.</p>
              <div className="mt-4 flex items-baseline gap-1">
                <span className="font-mono text-5xl font-black">$24.95</span>
                <span className="text-sm text-white/60">one-time</span>
              </div>
            </div>
            <div className="p-6">
              <ul className="space-y-3">
                {features.map((f) => (
                  <li key={f} className="flex items-start gap-2 text-sm">
                    <Check size={18} className="mt-0.5 shrink-0 text-mt-success" />
                    <span>{f}</span>
                  </li>
                ))}
              </ul>
              <Button onClick={handlePayPal} data-testid="paypal-button" className="mt-6 w-full gap-2 bg-[#FFC439] py-6 text-base font-bold text-[#1A1A1E] hover:bg-[#f0b72e]">
                Pay with PayPal
              </Button>
              <p className="mt-3 text-center text-xs text-mt-mutedfg">
                Secure checkout via PayPal. Your trial runs are saved and unlock instantly after purchase.
              </p>
            </div>
          </div>
        )}
      </motion.div>
    </div>
  );
}
